module.exports = __webpack_public_path__ + "img/logocom7.07f3a937.svg";